document.addEventListener('DOMContentLoaded', function () {
  // Singleton modal for all videos
  let videoModal = null;

  function closeModal() {
    if (videoModal) {
      videoModal.remove();
      videoModal = null;
      // Optionally: Restore scroll
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('.video-thumbnail').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {

      const videoUrlRaw = thumbnail.getAttribute('data-video-url');
      if (!videoUrlRaw) return;
      let videoUrl = '';
      if (videoUrlRaw.includes('youtube.com') || videoUrlRaw.includes('youtu.be')) {
        if (videoUrlRaw.includes('watch?v=')) {
          videoUrl = videoUrlRaw.replace('watch?v=', 'embed/');
        } else if (videoUrlRaw.includes('youtu.be')) {
          videoUrl = videoUrlRaw.replace('youtu.be/', 'www.youtube.com/embed/');
        } else {
          videoUrl = videoUrlRaw;
        }
        videoUrl += '?autoplay=1';
      } else if (videoUrlRaw.includes('vimeo.com')) {
        const match = videoUrlRaw.match(/vimeo\.com\/(\d+)/);
        console.log(match);
        if (match && match[1]) {
          videoUrl = `https://player.vimeo.com/video/${match[1]}?autoplay=1`;
        } else {
          alert('Invalid Vimeo URL!');
          return;
        }
      } else {
        alert('Unsupported video URL!');
        return;
      }

      // Remove any existing modal before rendering a new one
      closeModal();

      // Build modal HTML
      videoModal = document.createElement('div');
      videoModal.className = 'video-modal';
      videoModal.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 99999;
        top: 0; left: 0; width: 100vw; height: 100vh;
        background: rgba(0,0,0,0.95);
      `;

      videoModal.innerHTML = `
        <div style=" width: 82vw; aspect-ratio: 16/9; background: #000;">
          <button class="modal-close" type="button" aria-label="Close video" style="position:absolute;top:12px;right:24px;font-size:36px;color:white;background:none;border:none;z-index:2;cursor:pointer;">&times;</button>
          <iframe src="${videoUrl}" frameborder="0" allowfullscreen allow="autoplay; encrypted-media" style="width:100%;height:100%;border:none;display:block;z-index:1;"></iframe>
        </div>
      `;

      document.body.appendChild(videoModal);
      document.body.style.overflow = 'hidden'; // Prevent scroll behind modal

      // Close actions
      videoModal.querySelector('.modal-close').onclick = closeModal;
      videoModal.addEventListener('click', function (evt) {
        if (evt.target === videoModal) closeModal();
      });
      document.addEventListener('keydown', function escListener(e) {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', escListener);
        }
      });
    });
  });
});





// Swatch chnages
function updateVariantSwatchInfo() {
  var color = '';
  var style = '';
  var checkedInput = document.querySelector('input[type="radio"][data-variant-id]:checked');
  if (checkedInput) {
    color = checkedInput.dataset.variantSwatchColor || '';
    style = checkedInput.dataset.variantSwatchStyle || '';
  }

  var metaColorStyleDiv = document.querySelector('.meta-color-style');
  if (!metaColorStyleDiv) return;
  if (color && style) {
    metaColorStyleDiv.style.display = 'block';
    document.getElementById('variant-color').textContent = color;
    document.getElementById('variant-style').textContent = style;
  } else {
    metaColorStyleDiv.style.display = 'none';
    document.getElementById('variant-color').textContent = '';
    document.getElementById('variant-style').textContent = '';
  }
}


// On page load
document.addEventListener('DOMContentLoaded', updateVariantSwatchInfo);

// On change
document.addEventListener('change', function (event) {
  if (event.target.matches('input[type="radio"][data-variant-id]')) {
    requestAnimationFrame(updateVariantSwatchInfo);
  }
});

// On Shopify section/ajax redraw
document.addEventListener('shopify:section:load', function () {
  requestAnimationFrame(updateVariantSwatchInfo);
});

document.addEventListener('variant:change', function () {
  requestAnimationFrame(updateVariantSwatchInfo);
});

let productGuideReturnFocus = null;
function closeProductGuide(drawer) {
  drawer?.classList.remove('opened');
  document.body.classList.remove('productGuideDrawerOpened');
  productGuideReturnFocus?.focus({ preventScroll: true });
  productGuideReturnFocus = null;
}

document.addEventListener('click', function (event) {
  const openButton = event.target.closest('.product_guide_drawer_open_link');
  if (openButton) {
    const selector = openButton.getAttribute('data-target') || openButton.getAttribute('target');
    if (!selector || !selector.startsWith('#')) return;
    const drawer = document.querySelector(selector);
    if (!drawer) return;
    event.preventDefault();
    productGuideReturnFocus = openButton;
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Product guide');
    drawer.classList.add('opened');
    document.body.classList.add('productGuideDrawerOpened');
    setTimeout(() => {
      if (drawer.classList.contains('opened')) drawer.querySelector('.product_guide_drawer_close_bttn')?.focus({ preventScroll: true });
    }, 350);
    return;
  }

  const closeButton = event.target.closest('.product_guide_drawer_close_backdrop, .product_guide_drawer_close_bttn');
  if (!closeButton) return;
  event.preventDefault();
  closeProductGuide(closeButton.closest('.product_guide_drawer'));
});

document.addEventListener('keydown', function (event) {
  const drawer = document.querySelector('.product_guide_drawer.opened');
  if (!drawer) return;
  if (event.key === 'Escape') {
    event.preventDefault();
    closeProductGuide(drawer);
    return;
  }
  if (event.key !== 'Tab') return;
  const controls = [...drawer.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')].filter(element => element.getClientRects().length > 0);
  const first = controls[0], last = controls[controls.length - 1];
  if (!first) return;
  if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
    event.preventDefault(); last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
    event.preventDefault(); first.focus();
  }
});





